import { getAuthClientToken } from './client';

export const fetchAuthSession = async () => {
  const { data } = await getAuthClientToken();
  const token = data?.token ?? '';

  return {
    tokens: {
      idToken: { toString: () => token },
      accessToken: token,
    },
  };
};
